import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function SafetyPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-accent-50">
          <div className="max-w-3xl mx-auto">
            <nav className="text-sm text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">Safety Center</span>
            </nav>
            <div className="w-14 h-14 rounded-2xl bg-accent-500 text-background-50 flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-2xl"></i>
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
              Safety Center
            </h1>
            <p className="text-foreground-600 text-lg">
              Essential safety tips for researching and buying through CSSBuy. Protect yourself, your data, and your money.
            </p>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto space-y-8">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">Account Security</h2>
              <p className="text-foreground-700 mb-2">Never share your CSSBuy password, verification codes, or authentication tokens with anyone. CSSBuy staff will never ask for your password.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">Seller Verification</h2>
              <p className="text-foreground-700 mb-2">Always verify sellers through multiple sources. Check ratings, reviews, and transaction history before placing an order.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">Link Safety</h2>
              <p className="text-foreground-700 mb-2">Be cautious of shortened links or suspicious URLs. Only click links from trusted sources and verify the domain before entering any information.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">Payment Safety</h2>
              <p className="text-foreground-700 mb-2">Use official payment methods only. Never send money directly to sellers outside of the official CSSBuy platform.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">Phishing Awareness</h2>
              <p className="text-foreground-700 mb-2">Watch out for fake emails, messages, or websites pretending to be CSSBuy. Always access CSSBuy through official channels.</p>
            </div>
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">QC and Product Safety</h2>
              <p className="text-foreground-700 mb-2">Always request and review QC photos before shipping. If something looks wrong, contact support before approving the shipment.</p>
            </div>
            <div className="bg-accent-50 rounded-xl p-6 border border-accent-200/50">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-2">Important Disclaimer</h2>
              <p className="text-foreground-700 text-sm">This website is an independent resource and is not affiliated with CSSBuy. We do not guarantee product quality, seller behavior, shipping times, or refund outcomes. Always verify information through official CSSBuy channels.</p>
            </div>
            <div className="text-center">
              <a href="/" className="inline-flex items-center px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors">
                <i className="ri-arrow-left-line mr-2"></i>
                Back to Homepage
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}